import type { UnifiedSignupScreenName } from './Form/coordinator/UnifiedSignup/UnifiedSignupScreenName';

// Start/Intent screens
import UssStartScreen from './UssStartScreen.vue';
import UssIntent from '~/components/Atmos/SignUpPartials/UssIntent/UssIntent.vue';
import UssPersonaBizIntent from '~/components/Atmos/SignUpPartials/UssPersonaBizIntent/UssPersonaBizIntent.vue';
import UssPersonaEduIntent from '~/components/Atmos/SignUpPartials/UssPersonaEduIntent/UssPersonaEduIntent.vue';
import UssPersonaHobbyIntent from '~/components/Atmos/SignUpPartials/UssPersonaHobbyIntent/UssPersonaHobbyIntent.vue';
import UssPersonaEduConverge from '~/components/Atmos/SignUpPartials/UssPersonaEduConverge/UssPersonaEduConverge.vue';

// Plan selection screens
import UssPlanSection from '~/components/Atmos/SignUpPartials/UssPlanSelection/UssPlanSection.vue';

// Error screens
import UssEmailCheck204Screen from '~/components/Atmos/SignUpPartials/UssEmailCheck204Screen/UssEmailCheck204Screen.vue';
import UssEmailCheck422Screen from '~/components/Atmos/SignUpPartials/UssEmailCheck422Screen/UssEmailCheck422Screen.vue';
import UssEmailCheck500Screen from '~/components/Atmos/SignUpPartials/UssEmailCheck500Screen/UssEmailCheck500Screen.vue';

// Details screens
import ProDetails1SignupScreen from '~/components/Atmos/SignUpPartials/ProDetails1SignupScreen/ProDetails1SignupScreen.vue';
import ProDetails2SignupScreen from '~/components/Atmos/SignUpPartials/ProDetails2SignupScreen/ProDetails2SignupScreen.vue';
import EduDetailsEducatorSignupScreen from '~/components/Atmos/SignUpPartials/EduDetailsEducatorSignupScreen/EduDetailsEducatorSignupScreen.vue';
import EduDetailsStudentSignupScreen from '~/components/Atmos/SignUpPartials/EduDetailsStudentSignupScreen/EduDetailsStudentSignupScreen.vue';
import EduDetailsStudentK12SignupScreen from '~/components/Atmos/SignUpPartials/EduDetailsStudentK12SignupScreen/EduDetailsStudentK12SignupScreen.vue';
import FreeDetails1SignupScreen from '~/components/Atmos/SignUpPartials/FreeDetails1SignupScreen/FreeDetails1SignupScreen.vue';
import FreeDetails2SignupScreen from '~/components/Atmos/SignUpPartials/FreeDetails2SignupScreen/FreeDetails2SignupScreen.vue';
import StandardDetailsScreen from '~/components/Atmos/SignUpPartials/StandardDetailsScreen/StandardDetailsScreen.vue';

// Final screens
import UssSignupSuccessScreen from '~/components/Atmos/SignUpPartials/UssSignupSuccessScreen/UssSignupSuccessScreen.vue';
import SignupSuccessRedirectSignupScreen from '~/components/Atmos/SignUpPartials/SignupSuccessRedirectSignupScreen/SignupSuccessRedirectSignupScreen.vue';
import UssSignupFailScreen from '~/components/Atmos/SignUpPartials/UssSignupFailScreen/UssSignupFailScreen.vue';
import UssErrorAgeUnderThirteen from '~/components/Atmos/SignUpPartials/UssErrorAgeUnderThirteen/UssErrorAgeUnderThirteen.vue';

// Other screens
import HomePageNameSignupScreen from '~/components/Atmos/SignUpPartials/HomePageNameSignupScreen/HomePageNameSignupScreen.vue';
import SubmittingFormLoadingSignupScreen from '~/components/Atmos/SignUpPartials/SubmittingFormLoadingSignupScreen/SubmittingFormLoadingSignupScreen.vue';
import SignupSubmittingSignupScreen from '~/components/Atmos/SignUpPartials/SignupSubmittingSignupScreen/SignupSubmittingSignupScreen.vue';
import ErrorOutSignupScreen from '~/components/Atmos/SignUpPartials/ErrorOutSignupScreen/ErrorOutSignupScreen.vue';
import UssEmailCheck401Screen from '~/components/Atmos/SignUpPartials/UssEmailCheck401Screen/UssEmailCheck401Screen.vue';

export const screenComponentMap: Record<UnifiedSignupScreenName, Component | undefined> = {
  // Start screens
  'uss-start-signup': UssStartScreen,
  'uss-start-free': UssStartScreen,
  'uss-start-trial': UssStartScreen,
  'uss-start-edu': UssStartScreen,
  'uss-start-landing': UssStartScreen,
  'uss-start-standard': UssStartScreen,
  'uss-start-home-page': UssStartScreen,

  // Intent screens
  'uss-intent': UssIntent,
  'uss-persona-biz-intent': UssPersonaBizIntent,
  'uss-persona-edu-intent': UssPersonaEduIntent,
  'uss-persona-hobby-intent': UssPersonaHobbyIntent,
  'uss-persona-edu-converge': UssPersonaEduConverge,

  // Plan selection screens
  'uss-choose-pro-edu': UssPlanSection,
  'uss-choose-pro-free': UssPlanSection,
  'uss-choose-pro-free-edu': UssPlanSection,
  'uss-choose-pro-free-educator': UssPlanSection,
  'uss-choose-hlfree-pro-edu': UssPlanSection,
  'uss-choose-free-hlpro-edu': UssPlanSection,
  'uss-choose-free-edu': UssPlanSection,
  'uss-choose-free-educator': UssPlanSection,
  'uss-explain-pro': UssPlanSection,
  'uss-explain-free': UssPlanSection,
  'uss-explain-edu': UssPlanSection,
  'uss-explain-educator': UssPlanSection,
  'uss-divert-edu': UssPlanSection,
  'uss-divert-educator': UssPlanSection,
  'uss-divert-pro': UssPlanSection,
  'uss-divert-free': UssPlanSection,
  'uss-divert-free-pro': UssPlanSection,
  'uss-see-other-options': UssPlanSection,

  // Error screens
  'uss-email-check-204': UssEmailCheck204Screen,
  'uss-email-check-401': UssEmailCheck401Screen,
  'uss-email-check-422': UssEmailCheck422Screen,
  'uss-email-check-500': UssEmailCheck500Screen,
  'uss-error-age-under-thirteen': UssErrorAgeUnderThirteen,
  'uss-error-out': ErrorOutSignupScreen,

  // Details screens
  'uss-details-pro-1of2': ProDetails1SignupScreen,
  'uss-details-pro-2of2': ProDetails2SignupScreen,
  'uss-details-edu-educator': EduDetailsEducatorSignupScreen,
  'uss-details-edu-student': EduDetailsStudentSignupScreen,
  'uss-details-edu-student-k12': EduDetailsStudentK12SignupScreen,
  'uss-details-free-1of2': FreeDetails1SignupScreen,
  'uss-details-free-2of2': FreeDetails2SignupScreen,
  'uss-details-standard': StandardDetailsScreen,

  // Final screens
  'uss-signup-success': UssSignupSuccessScreen,
  'uss-signup-success-signin-redirect': SignupSuccessRedirectSignupScreen,
  'uss-signup-fail': UssSignupFailScreen,

  // Other screens
  'uss-signup-hp-name': HomePageNameSignupScreen,
  'uss-signup-email-status': SubmittingFormLoadingSignupScreen,
  'uss-signup-form-submitting': SignupSubmittingSignupScreen,

  // Not implemented
  'uss-ab-test': undefined,
  'not-implemented': undefined,
};
